// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"d3221f6c","189":"05a373c1","202":"cbb0db52","217":"9bb8a378","223":"3e97457e","422":"d4553934","921":"322d3890","983":"c0daa952"}[chunkId] + ".chunk.js";
};